import { render, staticRenderFns } from "./storeEdit.vue?vue&type=template&id=338fd662&scoped=true"
import script from "./storeEdit.vue?vue&type=script&lang=js"
export * from "./storeEdit.vue?vue&type=script&lang=js"
import style0 from "./storeEdit.vue?vue&type=style&index=0&id=338fd662&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338fd662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('338fd662')) {
      api.createRecord('338fd662', component.options)
    } else {
      api.reload('338fd662', component.options)
    }
    module.hot.accept("./storeEdit.vue?vue&type=template&id=338fd662&scoped=true", function () {
      api.rerender('338fd662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen-product/components/storeEdit.vue"
export default component.exports